import { render, staticRenderFns } from "./PopupPlayground.vue?vue&type=template&id=1b1b4d2a&scoped=true&"
import script from "./PopupPlayground.vue?vue&type=script&lang=js&"
export * from "./PopupPlayground.vue?vue&type=script&lang=js&"
import style0 from "./PopupPlayground.vue?vue&type=style&index=0&id=1b1b4d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b4d2a",
  null
  
)

export default component.exports